import axios from './../../api';
import store from './../../store';

export default {
  namespaced: true,

  state: {
    referents: [],
    referentToEdit: {},
    errors: null,
  },
  getters:{
    referents(state){
      return state.referents;
    },
        
    referentToEdit(state){
      return state.referentToEdit;
    },

    errors(state){
      return state.errors;
    },
  },
  mutations: {
    SET_REFERENTS(state, list){
      state.referents = list;
    },

    SET_REFERENTTOEDIT(state, referent){
      state.referentToEdit = JSON.parse(JSON.stringify(referent));
    },

    SET_ERRORS(state, err){
      state.errors = err;
    },
  },
  actions:{
    /**
         * load all roles created in current company
         * @param {*} context 
         */
    async loadReferents(context){
      console.log('wait...loading referents');

      await axios.get('api/referents').then((response) => {
        let referents = response.data;
        context.commit('SET_REFERENTS', referents);
      });
    },


    /**
         * create a user with referent role in current company 
         * @param {*} context 
         */
    async createReferent(context){
      store.commit('permissions/SET_SAVING', true);

      return await axios.post('/api/referents', context.getters.referentToEdit).then(() => {
        context.dispatch('loadReferents');
        return true;
      })
        .catch(error => {
          console.log('ERRRR:: ', error.response.data.errors);
                
          let errors = error.response.data.errors;
          errors.newMail = ((errors || {}).email || []);
          errors.newRole = ((errors || {}).role || []);

          store.commit('permissions/SET_ERRORS', error.response.data.errors);
          store.commit('permissions/SET_SAVING', false);
          return false;
        });
    },

    /**
         * attach an existing referent in current company 
         * @param {*} context 
         */
    async attachReferent(context){
      store.commit('permissions/SET_SAVING', true);

      return await axios.post('/api/users/attachReferent', context.getters.referentToEdit).then(() => {
        context.dispatch('loadReferents');
        return true;
      })
        .catch(error => {
          console.log('ERRRR:: ', error.response.data.errors);
                
          let errorMsg = error.response.data.errors;

          switch (errorMsg) {
          case 'already_attached': //if referent already attached on this company
            if(context.getters.referentToEdit.username != '')
              errorMsg = {'username': ['L\'utilisateur est déjà rattaché à la structure']};

            if(context.getters.referentToEdit.email != '')
              errorMsg = {'existingMail': ['L\'utilisateur est déjà rattaché à la structure']};
            break;
          case 'wrong_id':
            if(context.getters.referentToEdit.username != '')
              errorMsg = {'username': ['Cet utilisateur n\'existe pas']};

            if(context.getters.referentToEdit.email != '')
              errorMsg = {'existingMail': ['Cet utilisateur n\'existe pas']};
            break;
          default:
            errorMsg.existingMail = ((errorMsg || {}).email || []);
            errorMsg.existingRole = ((errorMsg || {}).role || []);

            break;
          }

          store.commit('permissions/SET_ERRORS', errorMsg);
          store.commit('permissions/SET_SAVING', false);
          return false;
        });
    },

    /**
         * Save referent informations modified by id (id referent is in newReferent)
         * @param {*} context 
         */
    async saveReferent(context) {
      store.commit('permissions/SET_SAVING', true);

      let referent = context.getters.referentToEdit;

      await axios.put('/api/users/'+referent.id, {user: referent}).then(() => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Les informations du référent '+referent.firstname+' '+referent.lastname+' ont bien été modifiées'});
        context.dispatch('loadReferents');
        store.commit('permissions/SET_SAVING', false);
        store.commit('permissions/SET_ERRORS', []);
        context.commit('SET_ERRORS', null);
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      })
        .catch(error => {
          store.commit('permissions/SET_SAVING', false);
          context.commit('SET_ERRORS', error.response.data.errors);
          store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});
          setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
          console.log('ERRRR:: ', error.response.data);
        });
    },

    /**
         * Delete a referent by id
         * @param {*} context 
         * @param int id 
         */
    async deleteReferent(context){
      store.commit('permissions/SET_SAVING', true);
            
      let referent = context.getters.referentToEdit;

      await axios.delete('/api/referents/'+referent.id).then(() => {
        context.dispatch('loadReferents');
      }).catch(error => {
        console.log('ERRRR:: ', error.response);
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: error.response.data.errors});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      });
    },
  },
};